import { userActionTypes } from "./userTypes";

export const setAllJobs = (item) => ({
  type: userActionTypes.SET_ALL_JOBS,
  payload: item,
});
export const toggleRole = item => ({
  type: userActionTypes.TOGGLE_ROLE,
  payload: item,
});